import React, { useState } from "react";
import { Copy, Eye, EyeOff, CheckCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { toast } from "sonner";

const ApiKeyModal = ({ isOpen, onClose, apiKey, machineName }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      toast.success("Licence Code copied to clipboard");
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = apiKey;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      toast.error("Failed to copy Licence Code");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle className="h-5 w-5 text-green-500" />
            Machine Created Successfully
          </DialogTitle>
          <DialogDescription>
            Your machine "{machineName}" has been created. Please save the
            Licence Code below :
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <Alert>
            <AlertTitle>Licence Code:</AlertTitle>
            <AlertDescription className="flex items-center gap-2 border border-border rounded-xl">
              <div className="flex-1 p-3 rounded-md font-mono text-sm overflow-x-auto break-all">
                {apiKey}
              </div>
            </AlertDescription>
          </Alert>

          <div className="flex items-center gap-2">
            <Button onClick={handleCopy} className="flex-1" variant="outline">
              <Copy className="h-4 w-4 mr-2" />
              Copy Licence Code
            </Button>
          </div>

          <Alert>
            <AlertDescription className="text-sm">
              Enter this Licence Code in your application to activate the
              machine. Licence Code can only be used in the application once.
            </AlertDescription>
          </Alert>

          <div className="flex justify-end pt-4">
            <Button onClick={onClose}>Continue</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ApiKeyModal;
